export default {
  "pl": {
    "form": {
      "actions": {
        "cancel": "Anuluj",
        "saveChanges": "Zapisz zmiany"
      },
      "back": "Poprzedni krok",
      "password": "Hasło",
      "steps": "Krok {count} z {total}",
      "writeEmployeeNameReject": "Aby kontynuować, wpisz: <i><b>{employeeName}</b></i>."
    }
  }
}
